'use strict';

function ProgressSnake() {
  this.extends = [_ComponentDataBind];
  this.declaredClass = null;
  this.node = null;
  this.id = null;

  this.length = null; // 1-10
  this.percent = null; // percent

  this.duration = 1200;
  this.delay = 0;
  this.startValue = 0;

  this._classes = {
    class: 'progress-snake',
    // modifiers
    mod_show: 'progress-snake--show',
    // children
    svg: 'progress-snake__svg'
  };

  this._svgBegin = '<svg width="75px" height="61px" viewBox="-1 -1 75 61" preserveAspectRatio="xMidYMax meet"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">';
  this._svgEnd = '</g></svg>';
  this._svg_1 = '<path d="M1,28 L73,28" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" ></path>';
  this._svg_5 = ['<path d="M1.29346987,0.2421875 L67.2869444,0.2421875 C67.2869444,0.2421875 72.8415179,1.20145089 72.8415179,7.44977679 C72.8415179,13.6981027 66.8080357,14.3816964 66.8080357,14.3816964" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round"></path>', '<path d="M62.7959506,14.373093 L6.43415179,14.2522321 C6.43415179,14.2522321 0.188616071,15.0184152 0.188616071,21.2952009 C0.188616071,27.5719866 6.43415179,28.6595982 6.43415179,28.6595982"  stroke="#4F4F4F" stroke-width="2" stroke-linecap="round"></path>', '<path d="M10.402631,28.6595982 L67.4196429,28.6595982 C67.4196429,28.6595982 72.8415179,29.266183 72.8415179,35.7120536 C72.8415179,40.1489121 68.8045007,41.8939852 66.2880319,42.5507738"  stroke="#4F4F4F" stroke-width="2" stroke-linecap="round"></path>', '<path d="M62.523371,42.9210295 L6.43415179,42.8772321 C6.43415179,42.8772321 -0.319637362,43.5039024 0.188616071,49.9714522 C0.696869505,56.4390021 6.43415179,57.0535714 6.43415179,57.0535714"  stroke="#4F4F4F" stroke-width="2" stroke-linecap="round"></path>', '<path d="M10.7236298,57.0535714 L66.2918527,57.0535714"  stroke="#4F4F4F" stroke-width="2" stroke-linecap="round"></path>'];
  this._svg_10 = ['<path d="M1.29961143,0.2421875 L69.7028942,0.2421875 C69.7028942,0.2421875 72.8415179,0.667149474 72.8415179,3.43521185 C72.8415179,6.20327422 69.2239855,6.50611216 69.2239855,6.50611216 L66.6878701,6.50389762" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M63.1879622,6.50084149 L3.54187292,6.44875837 C3.54187292,6.44875837 0.188616071,6.78818407 0.188616071,9.56885439 C0.188616071,12.3495247 3.54187292,12.8313461 3.54187292,12.8313461 C3.54187292,12.8313461 5.60531504,12.8313461 6.63703611,12.8313461" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M9.82696213,12.8313461 L69.8355927,12.8313461 C69.8355927,12.8313461 72.8415179,13.1000684 72.8415179,15.9556447 C72.8415179,18.8112211 69.2239855,19.1499052 69.2239855,19.1499052 C69.2239855,19.1499052 67.4484161,19.1493638 66.5606314,19.1490932" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M63.0980124,19.1480375 L3.54187292,19.1298808 C3.54187292,19.1298808 -0.319637362,19.4075011 0.188616071,22.2726816 C0.696869505,25.1378621 3.54187292,25.4101216 3.54187292,25.4101216 C3.54187292,25.4101216 5.58444246,25.4089633 6.60572724,25.4083841" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M10.6166476,25.4061096 C32.5466747,25.3936733 69.700384,25.3726038 69.700384,25.3726038 C69.700384,25.3726038 72.8390076,25.7975658 72.8390076,28.5656282 C72.8390076,31.3336906 69.2214753,31.6365285 69.2214753,31.6365285 L67.1748596,31.6347414" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M63.0644272,31.6311521 L3.5393627,31.5791747 C3.5393627,31.5791747 0.186105853,31.9186004 0.186105853,34.6992707 C0.186105853,37.479941 3.5393627,37.9617624 3.5393627,37.9617624 L6.55924302,37.9617624" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M9.9989258,37.9617624 L69.8330824,37.9617624 C69.8330824,37.9617624 72.8390076,38.2304847 72.8390076,41.0860611 C72.8390076,43.9416374 69.2214753,44.2803215 69.2214753,44.2803215 C69.2214753,44.2803215 67.4189767,44.279772 66.5177273,44.2794972" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M62.4422445,44.2782547 L3.5393627,44.2602971 C3.5393627,44.2602971 -0.32214758,44.5379174 0.186105853,47.4030979 C0.694359287,50.2682784 3.5393627,50.5405379 3.5393627,50.5405379 L6.4130739,50.5405379" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M10,50.7519096 C31.9300271,50.7394733 69.0837364,50.7184039 69.0837364,50.7184039 C69.0837364,50.7184039 72.2223601,51.1433658 72.2223601,53.9114282 C72.2223601,56.6794906 68.6048277,56.9823285 68.6048277,56.9823285 L66.558212,56.9805414" stroke="#4F4F4F" stroke-width="2"></path>', '<path d="M7,56.9823285 L62.5923261,56.9823285"  stroke="#4F4F4F" stroke-width="2" transform="translate(34.796163, 57.982329) scale(-1, 1) translate(-34.796163, -57.982329) " ></path>'];

  this.init = function () {
    this._super();

    this.$node = $(this.node);
    this.$node.addClass(this._classes.class);

    // accessiblity
    this.$node.attr('role', 'progressbar');
    this.$node.attr('aria-valuemin', 0);
    this.$node.attr('aria-valuemax', 100);

    // update the display
    this.updateDisplay();
    this.$node.addClass(this._classes.mod_show);

    this.onDataBindUpdate('length', this.updateDisplay.bind(this));
    this.onDataBindUpdate('percent', this.updateDisplay.bind(this));
  };

  this.initAllReady = function () {};
  this.destroy = function () {
    this._super();
  };

  this.updateDisplay = function () {
    this.$node.empty();
    // if (!this.$svg) {
    var svg = this._svgBegin;
    var offset = 0; // position offset to center the paths in the viewBox
    var scale = 0;
    if (this.length == 1) {
      svg += '<g id=\'bg\'>' + this._svg_1 + '</g>';
      svg += '<g id=\'ad\'>' + this._svg_1 + '</g>';
    } else if (this.length <= 5) {
      svg += '<g id=\'bg\'>' + this._svg_5.join(' ') + '</g>';
      svg += '<g id=\'ad\'>' + this._svg_5.join(' ') + '</g>';
      offset = (5 - this.length) / 3;
    } else {
      svg += '<g id=\'bg\'>' + this._svg_10.join('') + '</g>';
      svg += '<g id=\'ad\'>' + this._svg_10.join('') + '</g>';
      offset = (10 - this.length) / 4;
      scale = 1 + offset * offset * 0.4;
    }
    svg += this._svgEnd;
    this.$svg = $(svg);

    this.$svg.attr('class', this._classes.svg);

    this.$completion = this.$svg.find('g#ad'); // select the first path
    this.$svg.find('> g').attr('transform', scale ? 'scale(1,' + scale + ')' : 'translate(0,' + offset * offset * 21 + ')');

    // hide all the paths that are not necessary for this length
    this.$svg.find('path:nth-child(n+' + (this.length + 1) + ')').css('display', 'none');

    this.$node.append(this.$svg);
    // }

    this.$node.attr('aria-valuenow', this.percent);
    this._animateDelay = setTimeout(this.animateDisplay.bind(this), this.delay);
  };

  this.animateDisplay = function () {
    $({ value: this.startValue }).animate({ value: this.percent }, {
      queue: false,
      easing: 'easeOutCubic',
      duration: this.duration,
      step: function (value) {
        var _this = this;

        var result = value * this.length;

        this.$completion.find('path').each(function (index, element) {
          if (index < _this.length) {
            // only animate visible elements
            var $element = $(element);
            var isLast = $element.is(':last-child');
            var isFirst = $element.is(':first-child');

            // min range 61/82/91
            // max range 0
            var complete = 82;
            if (isFirst && isLast || !isFirst && !isLast) {
              complete = 82;
            } else if (isFirst) {
              complete = 91;
            } else if (isLast) {
              complete = 61;
            }

            var current = 0; // incomplete
            if (result < index + 1) {
              if (result > index) {
                current = complete - complete * (result - index); // progress
              } else {
                current = complete; // complete
              }
            }
            $element.css('stroke-dashoffset', current);
          }
        });
      }.bind(this),

      complete: function (value) {
        this.startValue = this.percent;
      }.bind(this)
    });
  };
}